import React from 'react';
import { useAppDispatch } from 'app/store';
import { deleteFolderEffect } from 'app/store/SongList/effects';
import { ChakraConfirmationDialog } from 'app/components/Dialogs';
import { FolderItem } from 'types/song';
import { getFolderLocalStorageKey } from 'app/components/Song/SongList/utils';
import { removeSiteSetting } from 'app/utils/hooks';

interface SongFolderRemoveDialogProps {
  songFolder: FolderItem | null;
  open: boolean;
  onClose: () => void;
}

export const SongFolderRemoveDialog: React.FC<SongFolderRemoveDialogProps> = ({
  songFolder,
  open,
  onClose,
}) => {
  const dispatch = useAppDispatch();

  if (!songFolder) {
    return null;
  }

  const { guid, title } = songFolder;
  const handleAction = () => {
    dispatch(
      deleteFolderEffect({
        guid,
      })
    );
    removeSiteSetting(getFolderLocalStorageKey(songFolder));
    onClose();
  };

  return (
    <ChakraConfirmationDialog
      title="Remove Song Folder"
      actionButtonText="Remove"
      handleAction={handleAction}
      isOpen={open}
      onClose={onClose}
      message={
        <>
          Are you sure you want to remove song folder: <b>{title}</b>
        </>
      }
    />
  );
};
